import React, { ReactElement } from 'react';
import { Typography } from 'antd';
import { Chart, VizState } from '@threatadvisor/react-components';

export type EventClosureStatusByWeekProps = {
  clientUid: string;
  reportStart: string;
  reportEnd: string;
};

export default function EventClosureStatusByWeek(
  props: EventClosureStatusByWeekProps
): ReactElement {
  const { clientUid, reportStart, reportEnd } = props;

  const cubeQueryConfig: VizState = {
    chartType: 'line',
    pivotConfig: {
      x: ['security_event.firstActionDate.week'],
      y: ['security_event.closedReason', 'measures'],
      fillMissingDates: true
      //joinDateRange: false
    },
    query: {
      measures: ['security_event.count'],
      order: {
        'security_event.count': 'desc'
      },
      dimensions: ['security_event.closedReason'],
      timeDimensions: [
        {
          dimension: 'security_event.firstActionDate',
          granularity: 'week',
          dateRange: [reportStart, reportEnd]
        }
      ],
      filters: [
        {
          member: 'security_event.status',
          operator: 'notEquals',
          values: ['New']
        },
        {
          member: 'security_event.clientUid',
          operator: 'equals',
          values: [clientUid]
        }
      ]
    }
  };

  return (
    <>
      <h2 className="text-uppercase">Event Closure Status By Week</h2>

      <figure>
        <Chart
          chartConfig={{
            scale: {
              x: {
                type: 'time'
              }
            },
            legend: {
              color: {
                itemLabelText: ({ id, label, color }, index) => {
                  return label === 'Undefined' ? 'Promoted' : label;
                },
                title: false,
                position: 'top',
                layout: {
                  justifyContent: 'flex-end',
                  alignItems: 'flex-end',
                  flexDirection: 'column'
                }
                //rowPadding: 5,
              }
            },
            colorField: 'series'
          }}
          config={cubeQueryConfig}
        />
        <figcaption>
          <Typography.Text type="secondary">
            Shows trending data for event closure / resolution reasons or if promoted to an existing
            case by week.
          </Typography.Text>
        </figcaption>
      </figure>
    </>
  );
}
